import axios from "axios";

export const fetchAllocationDetails = async (id, token, exportVal = false,portfolio) => {

    const params = {};
    if (exportVal) params.export = true;
    if (portfolio) params.portfolio = portfolio;
  try {
    const res = await axios.get(`portfolio/user-cases/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
        
      },

      params
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const postAllocateCase = async (body, token) => {
  const urls = {
    supervisors: "agency/allocate-supervisor/",
    field_agents: "agency/allocate-field-agent/",
    teamleads: "agency/allocate-teamlead/",
    telecallers: "agency/allocate-tellecaller/",
  };
  try {
    const res = await axios.post(urls?.[body?.role_type], body?.payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const patchEmployeeDetails = async (payload, token) => {
  try {
    const res = await axios.put("auth/admin/user-update-details/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data ?? error;
    }
    throw error;
  }
};


export const ChangeCaseToUnallocate = (payload, token) => {
  try {
    const res = axios.post('agency/unallocate-case/', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res;
  } catch (error) {
    return error;
  }
}

export const getFieldAgentLocation = async (token, fa_id) => {
  try {
    const response = await axios.get(
      "/agency/admin/field-agent-location-tracking/",
      {
        params: { fa_id: fa_id },
        headers: {
          Authorization: `Bearer ${token}`,  // Attach token here
        },
      }
    );


    return response;
  } catch (error) {
    console.error("Error fetching agent location:", error);
    throw error;
  }
}
export const getFieldAgentCaseDetails = async (token, id) => {
  try {
    const response = await axios.get(
      `portfolio/case-details/?case_id=${id}`,
      {

        headers: {
          Authorization: `Bearer ${token}`,  // Attach token here
        },
      }
    );


    return response;
  } catch (error) {
    console.error("Error fetching agent location:", error);
    throw error;
  }
}
